'use strict';

import React from "react";
import PropTypes from "prop-types";

import appStore from "@uw-it-sis/lib-react/lib/AppStore";

const analyticsStore = appStore.getAnalyticsStore();

const RegistrationCodeLink = (props) => {
    if (!props?.sln) {
        return null;
    }

    const onSectionStatusClick = () => {
        analyticsStore.addEvent("SectionStatusLinkClick", {}, props.additionalAnalytics);
    };

    let additionalAttr = {};
    if (props.className) {
        additionalAttr["className"] = props.className;
    }

    if (props.describedby) {
        additionalAttr["aria-describedby"] = props.describedby;
    }

    // Is user authenticated and there is a quarter year prop, but not social
    if ( appStore.isAuthenticated() && ! appStore.isSocialUser() && props.qtryr !== "" && props.qtryr !== null && props.sln !== "" && props.sln !== null ) {
        return (
            <a href={'https://sdb.admin.washington.edu/timeschd/uwnetid/sln.asp?QTRYR=' + props.qtryr + '&SLN=' + props.sln}
               target="_blank"
               onClick={onSectionStatusClick}
               aria-label={`SLN: ${props.sln}`}
               {...additionalAttr}>
                {props.sln}
            </a>
        );
    } else {
        return (
            <span {...additionalAttr}>
                <span className="sr-only">SLN:</span> {props.sln}
            </span>
        );
    }
}

RegistrationCodeLink.propTypes = {
    sln: PropTypes.string,
    qtryr: PropTypes.string,
    className: PropTypes.string,
    additionalAnalytics: PropTypes.object,
    describedby: PropTypes.string,
};

export default RegistrationCodeLink;
